import React from "react";
import { BiChevronDown } from "react-icons/bi";

// helpers
import { IScrollDown } from "./IScrollDown.d";

// assets
import styles from "@/assets/styles/components/scroll-down.module.scss";

function ScrollDown({ href, label = "Scroll Down", onScroll, className = "" }: IScrollDown) {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onScroll();
  };

  return (
    <a href={href} onClick={onClick} className={`${styles["locl-scroll-down"]} ${className}`}>
      <span className={styles["locl-scroll-down__arrow"]}>
        <BiChevronDown />
      </span>
      <span className={styles["locl-scroll-down__label"]}>{label}</span>
    </a>
  );
}

export default ScrollDown;
